import { Badge, type BadgeProps } from '../ui/badge';
import { statusText } from '../../lib/operations/presentation';

// Colour describes the recorded state only; it does not establish readiness.
export function StatusBadge({ status, label, tone }: { status: string; label?: string; tone?: BadgeProps['variant'] }) {
  const value = status.toLowerCase();
  let variant: BadgeProps['variant'] = 'muted';
  if (
    ['pass', 'within_range', 'agreed', 'confirmed', 'auto_confirmed', 'succeeded', 'approved', 'accepted', 'completed', 'delivered', 'applied', 'active', 'resolved'].includes(
      value
    )
  )
    variant = 'success';
  else if (
    ['unevaluated', 'under_inspection', 'proposed', 'raised', 'held', 'pending', 'ambiguous', 'unmatched', 'needs_review', 'escalated'].includes(value)
  )
    variant = 'warning';
  else if (['fail', 'out_of_range', 'disagrees', 'failed', 'rejected', 'blocked', 'error'].includes(value)) variant = 'destructive';
  else if (
    [
      'processing',
      'previewed',
      'matched',
      'in_transit',
      'shipped',
      'exported',
      'reviewed',
    ].includes(value)
  )
    variant = 'default';
  return (
    <Badge variant={tone ?? variant} className="max-w-full whitespace-normal capitalize">
      {label ?? statusText(status)}
    </Badge>
  );
}
